<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.goods_name" placeholder="请输入商品名称" style="width: 220px;" class="filter-item" clearable/>

      <el-input v-model="listQuery.shop_label" placeholder="请输入店铺标签" style="width: 220px;" class="filter-item" clearable/>

      <el-select class="filter-item" filterable v-model="listQuery.canteen_id" placeholder="请选择食堂" style="width: 145px" clearable>
        <el-option v-for="item in canteens" :key="item.id" :label="item.canteen_name" :value="item.id">
        </el-option>
      </el-select>

      <el-select class="filter-item" filterable v-model="listQuery.shop_id" placeholder="请选择店铺" style="width: 145px" clearable>
        <el-option v-for="item in shops" :key="item.id" :label="item.shop_name" :value="item.id">
        </el-option>
      </el-select>

      <el-select class="filter-item" filterable v-model="listQuery.category_id" placeholder="请选择分类" style="width: 145px" clearable>
        <el-option v-for="item in categories" :key="item.id" :label="item.category_name" :value="item.id">
        </el-option>
      </el-select>

      <el-select class="filter-item" filterable v-model="listQuery.audit_status" placeholder="请选择审核状态" style="width: 145px" clearable>
        <el-option label="审核中" :value="0"/>
        <el-option label="审核成功" :value="1"/>
        <el-option label="审核失败" :value="2"/>
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="店铺名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop.shop_name }}
        </template>
      </el-table-column>

      <el-table-column label="店铺标签" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.shop.shop_label }}
        </template>
      </el-table-column>

      <el-table-column label="分类" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.category.category_name }}
        </template>
      </el-table-column>

      <el-table-column label="商品名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.goods_name }}
        </template>
      </el-table-column>

      <el-table-column label="描述" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.goods_description }}
        </template>
      </el-table-column>

      <el-table-column label="封面" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.goods_thumb" class="user-avatar">
        </template>
      </el-table-column>

      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column>

      <el-table-column label="库存" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.goods_number }}
        </template>
      </el-table-column>

      <el-table-column label="审核状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.audit_status === 0" type="primary">审核中</el-tag>
          <el-tag v-else-if="scope.row.audit_status === 1" type="success">审核成功</el-tag>
          <el-tag v-else-if="scope.row.audit_status === 2" type="danger">审核失败</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="驳回原因" min-width="110" align="center">
        <template slot-scope="scope">
          <div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;" :title="scope.row.audit_fail_msg">{{ scope.row.audit_fail_msg ? scope.row.audit_fail_msg : "--" }}</div>
        </template>
      </el-table-column>

      <el-table-column label="审核时间" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.audit_time ? scope.row.audit_time : "--" }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleInfo(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>

    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-position="left" label-width="90px">
        <el-form-item label="店铺">
          <el-select v-model="form.shop_id" placeholder="请选择店铺" style="width: 140px" clearable disabled>
            <el-option v-for="item in shops" :key="item.id" :label="item.shop_name" :value="item.id">
            </el-option>
          </el-select>

          <el-select v-model="form.category_id" placeholder="请选择分类" style="width: 140px" clearable disabled>
            <el-option v-for="item in categoriesCopy" :key="item.id" :label="item.category_name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="店铺标签">
          <el-input v-model="form.shop.shop_label" placeholder="请输入店铺标签" disabled />
        </el-form-item>

        <el-form-item label="商品名称">
          <el-input v-model="form.goods_name" placeholder="请输入商品名称" disabled />
        </el-form-item>

        <el-form-item label="商品描述">
          <el-input v-model="form.goods_description" placeholder="请输入商品描述" disabled />
        </el-form-item>

        <el-form-item label="封面">
          <upload-one v-model="form.goods_thumb"></upload-one>
          <div style="font-size:12px;color:red;">*推荐尺寸：160*160</div>
        </el-form-item>

        <el-row>
          <el-col :span="10">
            <el-form-item label="商品价格">
              <el-input v-model="form.sell_price" type="number" min="0" placeholder="请输入商品价格" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="包装费">
              <el-input v-model="form.pack_fee" type="number" min="0" placeholder="请输入包装费" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="库存">
              <el-input v-model="form.goods_number" type="number" min="0" placeholder="请输入库存" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="10" :offset="2">
            <el-form-item label="权重">
              <el-input v-model="form.weight" type="number" min="0" placeholder="请输入权重" disabled />
            </el-form-item>
          </el-col>
        </el-row>

<!--        <el-form-item label="是否必选">-->
<!--          <el-switch v-model="form.is_require" :active-value="1" :inactive-value="0" disabled></el-switch>-->
<!--        </el-form-item>-->

        <el-form-item label="起送份数">
          <el-input v-model="form.send_limit" type="number" min="0" placeholder="请输入起送份数" disabled />
        </el-form-item>

        <el-form-item label="规格">
          <el-table size="mini" :data="form.specs" border fit>
            <el-table-column label="名称" align="center" min-width="120">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.spec_name" disabled />
              </template>
            </el-table-column>
            <el-table-column label="价格(元)" align="center" min-width="120">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.spec_price" type="number" min="0" disabled />
              </template>
            </el-table-column>
            <el-table-column label="库存" align="center" min-width="120">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.spec_num" type="number" min="0" disabled />
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="属性">
          <el-table size="mini" :data="form.attrs" border fit>
            <el-table-column label="名称" align="center" min-width="120">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.attr_name" disabled />
              </template>
            </el-table-column>
            <el-table-column label="值" align="center" min-width="240">
              <template slot-scope="scope">
                <div :key="index" v-for="(item,index) in scope.row.attr_val" style="margin-bottom: 10px;">
                  <el-input style="display: inline-block;width: 150px;margin-right: 10px;" size="mini" v-model="item.name" placeholder="属性值名称" disabled />
                  <el-input style="display: inline-block;width: 150px;margin-right: 10px;" size="mini" v-model="item.price" placeholder="属性值价格" @input="item.price=item.price.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" disabled />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

<!--        <el-form-item label="轮播图">-->
<!--          <upload-list v-model="form.imgs" disabled></upload-list>-->
<!--          <div style="font-size:12px;color:red;">*商城店铺必填，推荐尺寸：375*194</div>-->
<!--        </el-form-item>-->

<!--        <el-form-item label="商品详情">-->
<!--          <tinymce :height="400" v-model="form.content" :content="form.content" ref="tinymce"/>-->
<!--          <div style="font-size:12px;color:red;">*商城店铺必填</div>-->
<!--        </el-form-item>-->

        <el-form-item label="驳回原因" v-if="form.audit_status === 0">
          <el-input v-model="form.audit_fail_msg" placeholder="请输入驳回原因" type="textarea" :rows="4" />

          <div style="margin-top: 20px;">
            <el-button type="success" @click="saveData(form.id, 1)" :loading="btnLoading">审核通过</el-button>

            <el-button type="danger" @click="saveData(form.id, 2)" :loading="btnLoading">审核驳回</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">返回</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";
  import Tinymce from '@/components/Tinymce'

  export default {
    components: { Tinymce },
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          canteen_id: "",
          shop_id: "",
          category_id: "",
          goods_name: "",
          shop_label: "",
          audit_status: "",
        },
        dialogFormVisible: false,
        btnLoading: false,
        form: {
          id: "",
          school_id: "",
          shop_id: "",
          category_id: "",
          goods_id: "",
          goods_name: "",
          goods_description: "",
          goods_thumb: "",
          sell_price: "",
          pack_fee: "",
          goods_number: "",
          weight: "",
          content: "",
          imgs: [],
          is_require: "",
          send_limit: "",
          audit_status: "",
          audit_time: "",
          audit_fail_msg: "",
          specs: [],
          attrs: [],
          shop: {
            shop_label: "",
          },
        },
        canteens: [],
        shops: [],
        categories: [],
        categoriesCopy: [],
      };
    },
    created() {
      this.getList();
      this.getCanteenList();
      this.getShopList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      "listQuery.canteen_id": {
        handler(newValue, oldValue) {
          if (newValue !== "") {
            this.listQuery.shop_id = "";
            this.shops = [];
            this.listQuery.category_id = "";
            this.categories = [];
          }
          this.getShopList();
        },
        deep: true
      },
      "listQuery.shop_id": {
        handler(newValue, oldValue) {
          if (newValue === "") {
            this.categories = [];
            this.listQuery.category_id = "";
          } else if (newValue !== oldValue) {
            this.listQuery.category_id = "";
            this.getCategoryList();
          }
        },
        deep: true
      },
      "form.shop_id": {
        handler(newValue, oldValue) {
          if (newValue === "") {
            this.categoriesCopy = [];
            this.form.category_id = "";
          } else if (newValue !== oldValue) {
            this.getCategoryCopyList();
          }
        },
        deep: true
      },
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        if (newVal !== "") {
          this.listQuery.canteen_id = "";
          this.canteens = [];
          this.listQuery.shop_id = "";
          this.shops = [];
        }
        this.getList();
        this.getCanteenList();
        this.getShopList();
      },
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/goodsAudit/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      getCanteenList() {
        request({
          url: "/api/backend/canteen/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id
          }
        }).then(response => {
          this.canteens = response.data.data;
        });
      },
      getShopList() {
        request({
          url: "/api/backend/shop/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id,
            canteen_id: this.listQuery.canteen_id,
          }
        }).then(response => {
          this.shops = response.data.data;
        });
      },
      getCategoryList() {
        request({
          url: "/api/backend/category/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id,
            shop_id: this.listQuery.shop_id
          }
        }).then(response => {
          this.categories = response.data.data;
        });
      },
      getCategoryCopyList() {
        request({
          url: "/api/backend/category/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id,
            shop_id: this.form.shop_id
          }
        }).then(response => {
          this.categoriesCopy = response.data.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          shop_id: "",
          category_id: "",
          goods_id: "",
          goods_name: "",
          goods_description: "",
          goods_thumb: "",
          sell_price: "",
          pack_fee: "",
          goods_number: "",
          weight: "",
          content: "",
          imgs: [],
          is_require: "",
          send_limit: "",
          audit_status: "",
          audit_time: "",
          audit_fail_msg: "",
          specs: [],
          attrs: [],
          shop: {
            shop_label: "",
          },
        }
        this.btnLoading = false;
      },
      handleInfo(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        if(this.$refs.tinymce) this.$refs.tinymce.setContent(this.form.content)
        this.dialogFormVisible = true
      },
      saveData(id, status) {
        if (status === 2 && !this.form.audit_fail_msg) {
          this.$message({
            type: "warning",
            message: "驳回原因不能为空"
          });
          return;
        }

        this.btnLoading = true
        request({
          url: "/api/backend/goodsAudit/audit",
          method: "post",
          data: {
            id: id,
            audit_status: status,
            audit_fail_msg: this.form.audit_fail_msg,
          }
        }).then(() => {
          this.btnLoading = false
          this.dialogFormVisible = false
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.getList();
        }).catch(() => {
          this.btnLoading = false
        })
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 6px;
  }
</style>
